import { render, staticRenderFns } from "./newSiteSidebarFonts.vue?vue&type=template&id=366e0dac&scoped=true&"
import script from "./newSiteSidebarFonts.vue?vue&type=script&lang=js&"
export * from "./newSiteSidebarFonts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366e0dac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VHover,VProgressLinear,VSheet})
